import { render, staticRenderFns } from "./PlanEnded.vue?vue&type=template&id=228e7779&scoped=true&"
import script from "./PlanEnded.vue?vue&type=script&lang=js&"
export * from "./PlanEnded.vue?vue&type=script&lang=js&"
import style0 from "./PlanEnded.vue?vue&type=style&index=0&id=228e7779&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e7779",
  null
  
)

export default component.exports